import React from 'react';

import IconButton from '@material-ui/core/IconButton';

import PrimaryButton from '../../../../components/Buttons/PrimaryButton';
import WarningTooltip from "../../../../components/WarningTooltip";
import CompareIcon from "../../../../images/CompareIcon";


const PortfolioBuilderButton = (props) => {
  const Icon = () => <CompareIcon color={props.disabled && 'rgba(0, 0, 0, 0.26)'} />;

  return props.variant === 'icon'
    ?
      <WarningTooltip
        title={props.disabled ? props.disabledReason : props.text}
        icon={
          <IconButton classes={props.customClasses} color={'primary'} onClick={props.onButtonClick} disabled={props.disabled}>
            <Icon/>
          </IconButton>
        }
      />
    :
      <PrimaryButton
        id={props.id}
        variant={props.variant}
        text={props.text}
        onButtonClick={props.onButtonClick}
        icon={<Icon/>}
        disabled={props.disabled}
        tooltip={props.disabledReason}
        customClasses={props.customClasses}
      />
};

PortfolioBuilderButton.defaultProps = {
  variant: 'text',
  text: 'Portfolio Builder'
};

export default PortfolioBuilderButton;